
import { defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// interface IPropsType {
//   image: string;
//   title: string;
//   description: string;
//   hasGoback: boolean;
// }

export default defineComponent({
  name: 'Exception',
  props: {
    // 图片
    image: {
      type: String,
    },
    // 标题
    title: {
      type: String,
    },
    // 描述
    description: {
      type: String,
      default: '',
    },
    // 是否显示返回键
    hasGoback: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    const gobackFn = () => {
      router.go(-1);
    };

    const currentRoute = useRoute();
    const { goback } = currentRoute.query;
    const gobackShow = ref(goback === 'true');

    return {
      gobackShow,
      goback: gobackFn,
    };
  },
});
